import React from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const slogans = [
  "One day at time.",
  "First things first.",
  "But for the grace of God.",
  "Easy does it.",
  "Think think think.",
  "Learn to listen, listen to learn.",
  "Once an Alcoholic and Always Alcoholic.",
  "Live and let live.",
  "Keep It Simple.",
  "This, too, shall pass.",
  "Let go and let God.",
  "Keep coming back, it works if you work it.",
  "Progress not Perfection.",
  "I came; I came to; I came to believe (Steps 1,2,3).",
  "To be forgiven we must forgive.",
  "H.A.L.T.=Don't get too Hungry, Angry, Lonely or Tired.",
  "F.E.A.R.=Frustration, Ego, Anxiety, Resentment.",
  "E.G.O.=Edging God Out.",
  "G.O.D.=Good Orderly Direction.",
  "Live in the NOW.",
  "Faith without works is dead.",
  "A journey of a 1,000 miles begins with the first step.",
  "Sobriety is a journey, not a destination.",
  "Stick with the winners.",
  "Call your sponsor before, not after, you take the first drink.",
  "One drink is too many and thousand not enough.",
  "It works it really does! (page 88 in the Big Book).",
  "Willingness is the key.",
  "Where you go, there you are.",
  "There is no chemical solution to a spiritual problem.",
  "Faith is spelled a-c-t-i-o-n.",
  "Take the mess to your sponsor, take the message to the meeting.",
  "If I think, I won't drink. If I drink, I can't think.",
  "The 12 Steps tell us how it works; the 12 Traditions tell us why it works.",
  "You are not required to like it, you're only required to DO it.",
  "H.O.W.=Honesty, Open-mindedness, Willingness.",
  "Don't compare — identify.",
  "Don't intellectualize — utilize.",
  "RULE 62: don't take yourself seriously.",
  "Living in the here and now.",
  "The elevator is broken — use the Steps.",
  "Let it begin with me.",
  "Trust God, clean house, help others.",
  "There is no such thing as a bad meeting.",
  "Pain is the touchstone of spiritual growth.",
  "Be nice to newcomers — one day they may be your sponsor.",
  "There is no magic in recovery only miracles.",
  "Fear is the absence of faith.",
  "Courage is faith that has said its prayers.",
  "Respect the anonymity of others.",
  "Take the cotton out of your ears and put it in your mouth.",
  "Depression is anger turned inward.",
  "3 A's in A.A. — affection, attention, appreciation.",
  "A.A. is the last stop on the train.",
  "One is too many, a thousand is not enough.",
  "Don't work my program, or your program — work THE program.",
  "The definition of an alcoholic: an egomaniac with an inferiority complex.",
  "The farther I get from my last drink, the closer I get to my next drunk.",
  "F.E.A.R.= False Evidence Appearing Real.",
  "F.E.A.R.=False Expectations Appearing Real.",
  "F.E.A.R.=Face Everything and Recover.",
  "F.E.A.R.=Forget Everything And Run.",
  "N.U.T.S.=Not Using the Steps.",
  "It's easy to talk the talk, but you have to walk the walk.",
  "A.A. is a school in which we are all learners and all teachers.",
  "The first step is the only step a person can work perfectly.",
  "Life starts when you stop.",
  "Fake it till you make it.",
  "Today there's still a monkey on my back. He's just sleeping. He's real easy to wake up.",
  "We have a disease that tells us we don't have a disease.",
  "We have a living problem, not a drinking problem.",
  "We have a thinking problem, not a drinking problem.",
  "If you don't want to slip, stay away from slippery places.",
  "My daily sobriety is contingent on my spiritual condition.",
  "Before engaging your mouth, put your mind in gear.",
  "My best friend became my worst enemy.",
  "When my insides match my outside, I'm practicing a good program.",
  "Today I soak up A.A. the way I used to soak up alcohol.",
  "When I drank, I was committing suicide on the installment plan.",
  "Minds are like parachutes — they won't work unless they're open.",
  "I'll always have another drunk in me, but I'm not sure I'll have another recovery.",
  "A winner is a loser who keeps trying.",
  "Today I have more solutions than problems.",
  "A.A. is a simple program for complicated people.",
  "When I start wondering if everything's okay, it's probably not.",
  "When the student is ready, the teacher appears.",
  "You can't speed up your recovery, but you sure can slow it down.",
  "Every drink I drank got me here. Every drink I don't drink keeps me here.",
  "It takes time to get your brains out of hock.",
  "A.A. is the highest priced club in the world. If you have paid the dues, why not enjoy the benefits?",
  "Stand by the coffee pot. It's a good way to meet people.",
  "It doesn’t matter how your jackass got in a ditch, just get him out.",
  "Lead us not into temptation. I can find it myself.",
  "Ask an alcoholic what time it is and he'll tell you how to build a clock.",
  "Sorrow shared is halved; joy shared is doubled.",
  "Always remember the insanity… Be thankful for the pain… But most of all be thankful for the days that went well.",
  "The road to resentment is paved with expectation.",
  "The lesson I must learn is simply that my control is limited to my own behavior, my own attitudes.",
  "Remember that alcoholism is incurable, progressive, and fatal.",
  "The road to sobriety is a simple journey for confused people with a complicated disease.",
  "Slogans are wisdom written in shorthand."
];

export default function SlogansPage() {
  const navigate = useNavigate();

  return (
    <section className="min-h-screen bg-gray-50 py-12 px-4 lg:px-8">
      <div className="max-w-6xl mx-auto">
        {/* Back Button */}
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 mb-8 text-blue-600 hover:underline text-lg font-medium"
        >
          <ArrowLeft className="w-5 h-5" />
          Back
        </button>

        {/* Title */}
        <h2 className="text-4xl font-bold text-gray-800 mb-10 text-center tracking-wide">
          AA Slogans
        </h2>

        {/* Slogans Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {slogans.map((s, i) => (
            <div
              key={i}
              className="bg-white border border-gray-100 shadow-sm hover:shadow-md hover:bg-blue-50 transition-all rounded-xl p-5 text-gray-800 text-justify font-medium leading-relaxed"
            >
              <span className="font-semibold text-blue-600 mr-2">{i + 1}.</span>
              {s}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
